import { render, staticRenderFns } from "./Zonal.vue?vue&type=template&id=2de64d6b&"
import script from "./Zonal.vue?vue&type=script&lang=js&"
export * from "./Zonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports